import { render } from "./ContactsBox.vue?vue&type=template&id=9e3c8c60&scoped=true"
import script from "./ContactsBox.vue?vue&type=script&lang=js"
export * from "./ContactsBox.vue?vue&type=script&lang=js"

import "./ContactsBox.vue?vue&type=style&index=0&id=9e3c8c60&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3c8c60"]])

export default __exports__